<template lang="">
  <div class="d-flex flex-column flex-root">
    <!-- <pre>{{ $route }}</pre> -->
    <Transition name="preloader">
      <div v-if="$store.state.preloader && $route.meta.preloader" class="preloader">
        <div class="preloader__image"></div>
      </div>
    </Transition>
    <div class="d-flex flex-column flex-root">
      <div class="d-flex flex-row flex-column-fluid page">
        <div v-if="configs" class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
          <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
            <nav-landing :configs="configs" />
            <div class="d-flex flex-column position-relative">
              <router-view :configs="configs" />
              <div v-if="$route.meta.floatIcon" class="position-sticky float-kritik">
                <router-link :to="{ name: 'kritik-saran' }" replace>
                  <img src="static/img/icon/float-web.png" class="d-none d-lg-block max-w-100px" />
                  <img src="static/img/icon/float-mobile.png" class="d-block d-lg-none max-w-80px" />
                </router-link>
              </div>
            </div>
          </div>
          <footer-landing :configs="configs" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'layout-landing',
  components: {
    FooterLanding: () => import('./footer.vue'),
    NavLanding: () => import('./navigation.vue')
  },
  data () {
    return {
      configs: null
    }
  },
  mounted () {
    this.getData()
    // console.log(this.$route)
  },
  methods: {
    getAPI (method, api, param, obj = null) {
      return this.$_api[method](api, param)
        .then((res) => {
          return obj ? res.data[obj] || res.data : res.data
        })
        .catch((err) => {
          this.$_alert.error(err)
        })
    },
    async getData () {
      this.configs = await this.getAPI('get', 'no-auth/config-landing')
      this.isLoading = false
    }
  }
}
</script>
<style lang="">
  .float-kritik {
    width: fit-content;
    margin-left: auto;
    bottom: 10px;
    right: 10px;
  }
  @media only screen and (min-width: 1190px) {
    .float-kritik {
      bottom: 20px;
      right: 30px;
    }
  }
  .preloader-enter-active,
  .preloader-leave-active {
    transition: opacity 0.25s;
  }
  .preloader-enter {
    opacity: 1;
  }
  .preloader-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .preloader {
    position: fixed;
    background-color: #fff;
    background-position: center center;
    background-repeat: no-repeat;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
    transition: all 500ms ease;
  }

  .preloader__image {
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-name: flipInY;
    animation-name: flipInY;
    -webkit-animation-duration: 2s;
    animation-duration: 2s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    background-image: url('/static/img/preload.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50px auto;
    width: 100%;
    height: 100%;
  }
  @media only screen and (min-width: 1190px) {
    .preloader__image {
      background-size: 150px auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/landing-page/components/layout.vue